/**
 * Created by ssuo on 5/18/2015.
 */
'use strict';

var keyMirror = require('keymirror');
var bundleRequestURI = '/myaccount/bundle';
var ppacRequestURI = '/myaccount/bundle/cards/anywhere';
var cardsRequestURI = '/myaccount/bundle/cards';

module.exports = {
    ActionTypes: keyMirror({
        ADDRESS_LIST_DATA_FETCH_SUCCESS: null,
        ADDRESS_LIST_DATA_FETCH_FAIL: null,
        ADDRESS_ADD_SUCCESS: null,
        ADDRESS_ADD_FAIL: null,

        NORMALIZE_ADDRESS_SUCCESS: null,
        NORMALIZE_ADDRESS_FAIL: null
    }),

    AppConstants: {
        UPDATE_PIN_URL: ppacRequestURI + '/update-pin/',
        REPORT_LOST_CARD_URL: ppacRequestURI + '/report-card-lost',
        REPLACE_DAMAGED_CARD_URL: ppacRequestURI + '/reissue/',
        CLOSE_CARD_URL: ppacRequestURI + '/close-card',
        REPLACE_CARD_URL: cardsRequestURI + '/:card_id/replace',
        UPDATE_PREFERRED_PAYMENT_URL: ppacRequestURI + '/update-funding-source/',
        CHANGE_ADDRESS_URL: ppacRequestURI + '/update-address/',
        ACTIVATE_APPLY_URL: ppacRequestURI + '/activate',
        NOTIFICATION_SETTINGS_URL: cardsRequestURI + '/notification-settings',
        LOW_BALANCE_SETTINGS_URL: bundleRequestURI + '/settings/lowbalance',
        UPDATE_LOW_BALANCE_URL: bundleRequestURI + '/settings/low-balance-alert/',

        ADDRESS_ADD_URL: bundleRequestURI + '/add-address/',
        NORMALIZE_ADDRESS_URL: bundleRequestURI + '/normalize-address',
        UPGRADE_URL: bundleRequestURI + '/upgrade',
        ENROLL_URL: bundleRequestURI + '/enroll',
        SIGNUP_UPGRADE_URL: bundleRequestURI + '/signup/upgrade',
        SIGNUP_ENROLL_URL: bundleRequestURI + '/signup/enroll',
        LOG_ERROR_URL: bundleRequestURI + '/error',

        PRODUCT_ELIGIBILITY_URL: bundleRequestURI + '/product-eligibility',

        MANUAL_TOPUP_URL: bundleRequestURI + '/manual-topup',

        ACCOUNT_GENERATION_URL: bundleRequestURI + '/test-accounts',

        APPLY_PRIMARY: {
            'CARD_ELIGIBILITY_STATUSES': keyMirror({
                ELIGIBLE_WITH_CONDITIONS: null,
                ELIGIBLE: null,
                INELIGIBLE: null,
                NEED_MORE_INFO: null,
                NEED_MORE_DATA: null,
                APPROVED: null,
                DENIED: null,
                MANUAL_REVIEW: null,
                ERROR: null,
                SIMILAR_PRODUCT_EXISTS: null,
                INVALID_ACCOUNT_STATE: null
            }),
            'CIP_FORM_FIELDS': keyMirror({ SSN9: null, DOB: null })
        },

        APPLY_CARD_STATUS: {
            APPROVED: 'APPROVED',
            NEED_MORE_DATA: 'NEED_MORE_DATA',
            MANUAL_REVIEW: 'MANUAL_REVIEW',
            STEPUP_AUTH: 'STEPUP_AUTH',
            DENIED: 'DENIED'
        },

        APPLY_CARD_ERROR_CODE: {
            NEED_MORE_INFO: 'NEED_MORE_INFO',
            CIP_FAILURE: 'CIP_FAILURE'
        },

        FLOW_NAME: {
            UPGRADE_BUNDLE: 'UPGRADE_BUNDLE',
            ACTIVATE_CARD: 'ACTIVATE_CARD',
            MANAGE_CARD: 'MANAGE_CARD',
            CHANGE_BILLING_ADDRESS: 'CHANGE_BILLING_ADDRESS',
            REPORT_LOST_CARD: 'REPORT_LOST_CARD',
            DAMAGED_CARD: 'DAMAGED_CARD',
            REPLACE_CARD: 'REPLACE_CARD'
        },

        MERCHANT: 'merchant',
        CONSUMER: 'consumer',
        ENROLL: 'ENROLL',
        UNENROLL: 'UNENROLL',
        PAYPAL_ANYWHERE_CARD_CARDHOLDER_AGREEMENT_LINK: 'https://www.paypal.com/us/webapps/mpp/ua/consumer-anywherecard-agreement',
        ELECTRONIC_COMMUNICATION_DELIVERY_POLICY_LINK: 'https://www.paypal.com/us/webapps/mpp/ua/esign-full',
        BANCORP_BANK_PRIVACY_POLICY_LINK: 'http://www.thebancorp.com/privacy-policy/',
        PP_DEBIT_CARD_DISPUTE_RESOLUTION_PAGE_URL: 'https://www.paypal.com/us/cgi-bin/webscr?cmd=_dc-claim&txn_id=',
        // User could choose not to set a BUF for a card, this constant is used for BUF id of this special case so our
        // program logic is consistent
        BUF_ID_OF_NO_BACKUP_FUNDING_SOURCE: -1,

        SUMMARY_PAGE_RELATIVE_URL: '/myaccount/bundle/summary',

        // Signup upgrade content key prefix
        KEY_PREFIX: {
            SIGNUP: 'signup_'
        },

        // normalize-address endpoint status
        // TODO: To standardize status code
        NORMALIZE_ADDRESS_STATUS: {
            NORMALIZE_VALID: 'valid',
            NORMALIZE_CORRECTED: 'corrected',
            NORMALIZE_INVALID: 'invalid',
            PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
            ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
            INVALID: 'INVALID'
        },
        NORMALIZE_ADDRESS_SCOPE: {
            MEDIUM: 'MEDIUM'
        },
        ADDRESS_STATUS: {
            VALID: 'VALID',
            INVALID: 'INVALID',
            CORRECTED: 'CORRECTED',
            PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
            ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
             // Validate Address - Error Response status is INVALID
            INVALID_INPUT: 'INVALID'
        },
        ADDRESS_STATUS_CONTENT_KEY: {
            PO_BOX_UNSUPPORTED: 'address_validation.invalid_po_box',
            US_TERRITORY_UNSUPPORTED: 'address_validation.invalid_territory_unsuppported',
            INVALID: 'address_validation.invalid_address'
        },
        ADDRESS_TYPE: {
            BILLING: 'BILLING',
            SHIPPING: 'SHIPPING'
        },
        INVALID_ADDRESS_REASON: {
            PO_BOX_NOT_ALLOWED: 'ADDRESS_PO_BOX_NOT_ALLOWED'
        },
        PIN_STATUS: {
            UNSET: 'UNSET',
            SET: 'SET'
        },
        PIN_ORIGIN: {
            SYSTEM: 'SYSTEM',
            USER: 'USER'
        },
        CARD_STATUS: {
            ACTIVE: 'ACTIVE',
            PENDING_ACTIVE: 'PENDING_ACTIVE'
        },
        REPLACE_CARD_REASON: {
            UNDELIVERABLE: 'UNDELIVERABLE',
            LOST_IN_TRANSIT: 'LOST_IN_TRANSIT'
        },
        TRAFFIC_SOURCE: {
            PEPPERJAM: 'pepperjam'
        }
    }
};



// WEBPACK FOOTER //
// ./public/js/constants.js